import React from "react";

export default function Copyright() {
  return (
    <div>
      <p className="copyright">
        Copyright 2020 Foodora.com | Developed by Renata.
      </p>
    </div>
  );
}
